import { Component, OnInit,TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Router,ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { CommonService } from './../services/common.service';

import { RoleService } from './../services/role.service';




@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.css']
})
export class RoleComponent implements OnInit {

  modalRef: BsModalRef;
  
  config :any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true
  };
  usermodel:any={}
  user_id:any=0;
  role_id:any=0;
  company_id:any=0;
  APIKEY:any=0;
  roleList:any='';
  role_per_option:any=[];
  rolePerForm: FormGroup;
  btnDisable: boolean = false;
  customer_value:boolean=false;
  user_value:boolean=false;
  soa_images_value:boolean=false;
  factoring_value:boolean=false;
  sctivity_value:boolean=false;
  company_setting_value:boolean=false;
  edit_role_id:any='0';
  
  role_name:any='';
  model:any={};
  module_name:any='User';

  constructor(private modalService: BsModalService,
    private _common:CommonService,private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private _router : Router,
    private _role : RoleService,
    ) { }

  ngOnInit() {
    this.user_id =localStorage.getItem('id');
    this.company_id =localStorage.getItem('company_id');
    this.APIKEY =localStorage.getItem('APIKEY');  
    this.role_id =localStorage.getItem('role_id');

    const data= {
      APIKEY : this.APIKEY,
      user_id : this.user_id,
      company_id : this.company_id,
      module:this.module_name,
      role_id:this.role_id,
    }

    this.checkpermission(data);
    this.getRoleList(data);
    this.role_per_option=[];
    this.setFormValue();


    
  }
    
  checkpermission(data){
    this._role.getUserModulePer(data)
    .subscribe(
      res => { 
        if(res.data.permission=='no'){
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('//setting/user-profile');
          });
        }
      },
    );
  }

   
  setFormValue(){
    this.rolePerForm = this.formBuilder.group({
        Customers: ['',],
        User: [''],
        SOA_Images: [''],
        Factoring: [''],
        Activity: [''],
        Company_Setting: [''],
    });
  }

  onSubmit() {
      const formData = new FormData();
      formData.append('Customers', this.rolePerForm.get('Customers').value);
      formData.append('User', this.rolePerForm.get('User').value);
      formData.append('SOA_Images', this.rolePerForm.get('SOA_Images').value);
      formData.append('Factoring', this.rolePerForm.get('Factoring').value);
      formData.append('Activity', this.rolePerForm.get('Activity').value);
      formData.append('Company_Setting', this.rolePerForm.get('Company_Setting').value);
      formData.append('role_id',this.edit_role_id);
      formData.append('role_name',this.role_name);
      formData.append('user_id', this.user_id);
      formData.append('company_id', this.company_id);
      formData.append('APIKEY', this.APIKEY);
      //console.log(formData); return false;   
      this._common.saveRolePerByid(formData).subscribe(
          res => { //console.log(res); return false;
            this.toastr.success(res.message, 'Success');
             this._router.navigateByUrl('/redirect').then(() => {
             this._router.navigateByUrl('/user/role');
            });
          }  
      );

  }

   getRoleList(data){
    this._common.getRoleList(data)
     .subscribe(
       res => { 
         this.roleList=res.data;
        },
     );
   }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template,this.config); 
  } 

  selectRole(value){
    const data={
      APIKEY : this.APIKEY,
      role_id : value,
      company_id : this.company_id
    };
    this.setFormValue();

    this.edit_role_id=value;
    this._common.getRolePerByid(data)
    .subscribe(
      res => { 
       this.role_per_option=res.data;
       this.role_name=res.data[0].role_name;

       if((res.data[0].role_name)!='Mobile User'){
          
          if(res.data[0].module_name=='Customers' && res.data[0].checked==1){
                this.rolePerForm.get('Customers').setValue('true');
          }
          if(res.data[1].module_name=='SOA_Images' && res.data[1].checked==1){
            this.rolePerForm.get('SOA_Images').setValue('true');
          }
          if(res.data[2].module_name=='Factoring' && res.data[2].checked==1){
            this.rolePerForm.get('Factoring').setValue('true');
          }
          if(res.data[3].module_name=='User' && res.data[3].checked==1){
            this.rolePerForm.get('User').setValue('true');
          }
          if(res.data[4].module_name=='Activity' && res.data[4].checked==1){
            this.rolePerForm.get('Activity').setValue('true');
          }
         
          if(res.data[5].module_name=='Company_Setting' && res.data[5].checked==1){
            this.rolePerForm.get('Company_Setting').setValue('true');
          }  
       }
       else{
          if(res.data[0].module_name=='SOA_Images' && res.data[0].checked==1){
            this.rolePerForm.get('SOA_Images').setValue('true');
          }
          
       }
      },
    );
  }

  add_role(){
    this.btnDisable = true;
    this.model["company_id"] = this.company_id;
    this.model["user_id"] = this.user_id;
    this.model["APIKEY"] = this.APIKEY;
    //console.log(this.model);  return false;   
    this._role.saveRole(this.model)
    .subscribe(
      res => {   //console.log(res); return false;
          if(res.status==true){
            this.toastr.success(res.message, 'Success');
          }
          else{
            this.toastr.error(res.message, 'Error');
          }
          this.modalRef.hide();
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/user/role');
          });
      },
    );


  }


}
